<template>
    <v-card class="ma-2">
        <v-toolbar flat dense>
            <v-toolbar-title class="subtitle-2">Clonagens já feitas</v-toolbar-title>

            <v-spacer/>

            <v-btn icon :loading="loading" @click="carregar(pagina)">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-toolbar>

        <v-data-table
            :headers="headers"
            :items="itens"
            :loading="loading"
            :mobileBreakpoint="0"
            :items-per-page="rows"
            :server-items-length="total"
            :page="pagina"
            :footer-props="{ itemsPerPageOptions: [30, 50, 100] }"
            dense
            @update:page="carregar($event)"
            @update:items-per-page="onRows"
        >
            <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
            </template>

            <template v-slot:item.rota="{ item }">
                {{ nome(item.origem, item.origem_db) }}
                <v-icon x-small>mdi-arrow-right</v-icon>
                {{ nome(item.destino, item.destino_db) }}
            </template>

            <template v-slot:item.status="{ item }">
                <v-chip x-small label dark :color="status(item.status).cor">
                    {{ status(item.status).texto }}
                </v-chip>

                <span v-if="item.etapa" class="caption grey--text ml-1">
                    {{ etapa(item.etapa) }}
                </span>

                <div v-if="item.erro" class="caption red--text">{{ item.erro }}</div>
            </template>

            <template v-slot:item.tabelas="{ item }">
                {{ (item.tabelas || []).length }}
                <div class="caption grey--text">{{ copiadas(item) }}</div>
            </template>

            <template v-slot:item.backup="{ item }">
                <span v-if="!item.backup_arquivo" class="grey--text">—</span>
                <span v-else :title="item.backup_arquivo">
                    {{ bytes(item.backup_bytes) }}
                    <div class="caption grey--text">
                        {{ item.backup_escopo === 'completo' ? 'banco inteiro' : 'tabelas afetadas' }}
                    </div>
                </span>
            </template>

            <template v-slot:item.duracao_ms="{ item }">
                {{ duracao(item.duracao_ms) }}
            </template>

            <template v-slot:item.user="{ item }">
                {{ (item.user && item.user.name) || 'sistema' }}
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { status, etapa, bytes, duracao } from './situacoes';

export default {
    name: 'TabHistorico',

    data: () => ({
        loading: false,
        itens: [],
        total: 0,
        pagina: 1,
        rows: 30,
        headers: [
            { text: 'Quando', value: 'created_at', sortable: false },
            { text: 'De → para', value: 'rota', sortable: false },
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Tabelas', value: 'tabelas', sortable: false },
            { text: 'Backup', value: 'backup', sortable: false },
            { text: 'Duração', value: 'duracao_ms', sortable: false },
            { text: 'Quem', value: 'user', sortable: false },
        ],
    }),

    mounted() {
        this.carregar(1);
    },

    methods: {
        status,
        etapa,
        bytes,
        duracao,

        nome(empresa, banco) {
            return (empresa && empresa.fantasia) || banco;
        },

        copiadas(item) {
            const linhas = item.progresso || [];
            const total = linhas.reduce((soma, l) => soma + (l.copiados || 0), 0);

            return total ? `${total} registro(s)` : '';
        },

        onRows(rows) {
            this.rows = rows;
            this.carregar(1);
        },

        async carregar(pagina = 1) {
            this.loading = true;
            this.pagina = pagina;

            try {
                const { data } = await this.$http.get('clonagem-cardapio/historico', {
                    params: { page: pagina, rows: this.rows },
                });

                this.itens = data.data || [];
                this.total = (data.meta && data.meta.total) || 0;
            } catch (e) {
                this.notify('Não foi possível carregar o histórico', 'error');
            }

            this.loading = false;
        },
    },
};
</script>
